import { ToastContainer, toast } from 'react-toastify';
import {useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import Panel from "../layout/components/Panel";
import Input from "../layout/components/Input";
import Button from "../layout/components/Button";
import { Auth } from '../common/AuthProvider';

export function Register () {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");   
    const[loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ termsAccepted: false });

    const handleRegister = () => {
        if (email === "" || password === "") {
            toast.error("Email and Password are required", {})
            return;
        }
        if (!formData.termsAccepted) {
            toast.error("You must agree to the Terms of Service", {})
            return;
        }
        setLoading(true)
        Auth.register({email: email, password: password}).then((response) => {
            toast.success("Account created successfully", {})
            setLoading(false)
            navigate('/register/success')
        }).catch((error) => {
            setLoading(false)
            toast.error(error.message.error, {})
        })
    }

    return (
        <>
            <ToastContainer/>
            <Panel title="Create an Account">      
                <p className="text-normal text-center text-general-80">Have an Account? &nbsp;
                    <Link to="/login" className="text-primary-100">Sign In</Link>
                </p>
                <div className="form-group mb-4 mt-8 text-center">
                    <Input
                        label="Email"
                        type="email"
                        placeholder="Enter Email Address"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>
                <div className="form-group mb-4 text-center">
                    <Input
                        label="Password"
                        type="password"
                        id="password"
                        placeholder="Enter Password (min 8 characters)"
                        onChange={(e) => setPassword(e.target.value)}
                        aria-describedby="passwordHelpBlock"
                    />
                </div>
                <div className="flex items-center mt-4">
                    <input
                        type="checkbox"
                        id="terms"
                        checked={formData.termsAccepted}
                        onChange={(e) => setFormData({...formData, termsAccepted: e.target.checked})}
                        className="w-4 h-4 text-primary-100 bg-gray-100 border-gray-300 rounded focus:ring-primary-100 focus:ring-2"
                        required
                    />
                    <label htmlFor="terms" className="ml-2 text-normal text-gray-700">
                        I agree to the <a href="https://www.ivestclub.fund/terms-of-service" target="_blank" className="text-primary-100 underline">Terms of Service</a>
                    </label>
                </div>
                
                <Button
                    className="w-full mt-4"
                    variant="primary" 
                    disabled={loading || !formData.termsAccepted || email === "" || password.length < 8}
                    onClick={() => handleRegister()}  
                >Create Account</Button>
            </Panel>
        </>
    )
}